export const TEST_ID = 'compactPill';
